/**
 * "Erika Mustermann": a customer's name, from what there is — the first name
 * is optional, and a missing part is left out rather than shown as "null".
 */
export const customerName = (
  customer: { firstname?: string | null; lastname?: string | null } | null | undefined
) => [customer?.firstname, customer?.lastname].filter(Boolean).join(' ')
